import { render, staticRenderFns } from "./ReturnedGoodsOfUserTableUser.vue?vue&type=template&id=23522564&scoped=true"
import script from "./ReturnedGoodsOfUserTableUser.vue?vue&type=script&lang=js"
export * from "./ReturnedGoodsOfUserTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23522564",
  null
  
)

export default component.exports